import * as React from "react";
const SvgPlusButton = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 14, viewBox: "0 0 15 14", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.5 8H8.5V14H6.5V8H0.5V6H6.5V0H8.5V6H14.5V8Z" }));
export default SvgPlusButton;
